export default "__VITE_ASSET__DWfoVUzs__"